import { render, staticRenderFns } from "./NoticeUser.vue?vue&type=template&id=d12adf26&"
import script from "./NoticeUser.vue?vue&type=script&lang=js&"
export * from "./NoticeUser.vue?vue&type=script&lang=js&"
import style0 from "./NoticeUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports